export const Users = [
    {
        id: 1,
        uid: "LqUv8lkoDAZJ4MsIJQBI5X5fbD53",
        email: "luizfernandocad@gmail.com",
        name: "Luiz Fernando",
        rule: 5
    }, {
        id: 2,
        uid: "ntQOHWpl89YHSqIAZRxGYy9Q2Yu1",
        email: "bpinheiro17@gmail.com",
        name: "Bruna Pinheiro",
        rule: 4
    }, {
        id: 3,
        uid: "HPmOqqPxdbag91JT9anBAK5Lyap2",
        email: "cyrcetns@gmail.com",
        name: "Cyrce Tadaiesky "
    }, {
        id: 4,
        uid: "qSi6KKlk1XeiEaF5Cm5F0Hpb6Gy1",
        email: "marcosh4@gmail.com",
        name: "Marcos Henderson"
    }, {
        id: 5,
        uid: "fb8k3U4A5Rgx8W8TnbsxXKKhHzx2",
        email: "keolli@gmail.com",
        name: "Kelly Lima"
    }, {
        id: 6,
        uid: "nN1gWYsArcfHd5FLXRo9yxmfZZR2",
        email: "gossardcarol@gmail.com",
        name: "Carol Souza"
    }, {
        id: 7,
        uid: "gP4rSjz3hzNmebNp7dACCdRmCTh1",
        email: "diario24horas.portal@gmail.com",
        name: "Diário HLG"
    }
]